<app-header *ngIf="!isAdminRoute"></app-header>
<main [class.min-h-screen]="!isAdminRoute">
  <router-outlet></router-outlet>
</main>
<app-footer *ngIf="!isAdminRoute"></app-footer>